<template>
  <div :class="computedClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  enableScroll?: boolean
}>()

const computedClasses = computed(() => {
  return [
    'space-y-3',
    {
      'overflow-y-auto': props.enableScroll,
    },
  ]
})
</script>
